import ExaminationEventSettingFields from './ExaminationEventSettingFields';

export default ExaminationEventSettingFields;
